"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = void 0;
const material_1 = require("@mui/material");
const useBreakpoints = () => {
    const theme = (0, material_1.useTheme)();
    // Screen is larger then 1200px
    // https://mui.com/material-ui/customization/breakpoints/
    const isDesktop = (0, material_1.useMediaQuery)(theme.breakpoints.up("lg"));
    // Smaller then 600px
    const isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down("sm"));
    return {
        isMobile,
        isDesktop,
    };
};
exports.useBreakpoints = useBreakpoints;
